import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/pages/Home/Home';
import * as params from '@/utils/urlParams';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/showcases',
        name: 'showcases',
        component: () => import('@/pages/Showcases/Showcases'),
    },
    {
        path: '/mien-bac',
        name: 'north',
        props: true,
        component: () => import('@/pages/North/North'),
    },
    {
        path: '/mien-trung',
        name: 'central',
        props: true,
        component: () => import('@/pages/Central/Central'),
    },
    {
        path: '/mien-nam',
        name: 'south',
        props: true,
        component: () => import('@/pages/South/South'),
    },
    {
        path: '/do-ket-qua',
        name: 'result',
        component: () => import('@/pages/Result/Result'),
    },
    {
        path: '/lich-su-cuoc',
        name: 'history',
        component: () => import('@/pages/History/History'),
    },
    {
        path: '*',
        name: 'notFound',
        component: () => import('@/pages/NotFound/NotFound.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

const hasQueryParam = (route, name) => {
    return (
        !!Object.keys(route.query).length &&
        Object.prototype.hasOwnProperty.call(route.query, name)
    );
};

router.beforeEach((to, from, next) => {
    let keepParams = {};
    if (
        hasQueryParam(from, [params.PARAM_TOKEN]) &&
        !hasQueryParam(to, [params.PARAM_TOKEN])
    ) {
        keepParams[params.PARAM_TOKEN] = from.query[params.PARAM_TOKEN];
    }
    if (
        hasQueryParam(from, [params.PARAM_IN_PAGE]) &&
        !hasQueryParam(to, [params.PARAM_IN_PAGE])
    ) {
        keepParams[params.PARAM_IN_PAGE] = from.query[params.PARAM_IN_PAGE];
    }
    if (Object.keys(keepParams).length) {
        next({
            ...to,
            query: { ...to.query, ...keepParams },
        });
    } else {
        next();
    }
});

export default router;
